/* eslint no-console:0 */
require("idempotent-babel-polyfill");

if (typeof L2H === 'undefined' || L2H === null) { window.L2H = {}; }
L2H.$ = $;
L2H.Handlebars = Handlebars;

require('google-analytics.js');
require('detect.js');
require("tracker.js");
require("internal-tracker.js");
require("shopables-view.js");
require("single-photo-view.js");
require("single-photo.js");


console.log("single photo code loaded");
